import React from 'react';
import { observer } from 'mobx-react-lite';
import { SectionTab } from 'polotno/side-panel';
import { Images } from './images';

import * as api from '../api';

export const MaterialsPanel = observer(({ store }) => {
  return (
    <div style={{ height: '100%', overflow: 'auto' }}>
      <Images
        store={store}
        api={api.ASSETS_API + '?artboardSection=materials'}
      />
    </div>
  );
});

export const MaterialsSection = {
  name: 'Materials',
  Tab: (props) => (
    <SectionTab name="Materials" {...props}>
      <img
        src={process.env.PUBLIC_URL + '/icons/materials.svg'}
        alt="Materials"
        style={{ width: '25px' }}
      />
    </SectionTab>
  ),
  Panel: MaterialsPanel,
};
